export default {
    image: 'image',
    index: 'index',
    text: 'text'
}